import Resources from ".";
import CreateNewResource from "./CreateNewResource";
import CreatePostWithMedia from "./CreatePostWithMedia";
import EditResource from "./EditResource";

export const resourcesRoutes = [
  {
    path: "/resources/new",
    exact: true,
    main: CreateNewResource,
  },
  {
    path: "/resources/:id",
    exact: true,
    main: EditResource,
  },
  {
    path: "/resources/:id/post",
    exact: true,
    main: CreatePostWithMedia,
  },
  {
    path: "/resources",
    exact: true,
    main: Resources,
  },
];
